<template>
  <b-tag v-if="level" :type="`is-${level} is-light`" size="is-small" rounded>
    🧩 Level {{ PUZZLE_COLOR_LEVELS[level] }}
  </b-tag>
</template>

<script>
import { PUZZLE_COLOR_LEVELS } from "vue-chess-shared/pgn/PgnParser";

export default {
  name: "PuzzleLevelBadge",

  props: {
    level: {
      type: String,
      required: true,
      validator: (value) => Object.keys(PUZZLE_COLOR_LEVELS).includes(value),
    },
  },

  data() {
    return {
      PUZZLE_COLOR_LEVELS,
    };
  },
};
</script>

<style scoped>
.tag.is-red {
  background-color: #ffebee;
  color: #c62828;
}
.tag.is-orange {
  background-color: #fff3e0;
  color: #ef6c00;
}
.tag.is-yellow {
  background-color: #fffde7;
  color: #f9a825;
}
.tag.is-green {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.tag.is-blue {
  background-color: #e3f2fd;
  color: #1565c0;
}
.tag.is-indigo {
  background-color: #e8eaf6;
  color: #283593;
}
.tag.is-violet {
  background-color: #f3e5f5;
  color: #6a1b9a;
}
</style>
